// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Simple QR Code System Styles */
.barcode-system {
  min-height: 100vh;
  background: #ffffff;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  padding: 20px;
}

/* Loading State */
.barcode-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #ffffff;
  color: #2d3748;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e2e8f0;
  border-top: 3px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.barcode-loading p {
  color: #4a5568;
  font-size: 1rem;
  font-weight: 500;
}

/* Header */
.barcode-header {
  background: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 20px 0;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.back-link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #667eea;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.back-link:hover {
  color: #5a67d8;
}

.page-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.title-icon {
  font-size: 1.5rem;
  color: #667eea;
}

.page-title h1 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.generate-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #667eea;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.generate-btn:hover {
  background: #5a67d8;
  transform: translateY(-1px);
}

/* Filters */
.barcode-filters {
  margin-bottom: 30px;
}

.search-section {
  margin-bottom: 20px;
}

.search-box {
  position: relative;
  max-width: 400px;
}

.search-box input {
  width: 100%;
  padding: 12px 16px 12px 40px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: white;
  color: #2d3748;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.search-box input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.search-box input::placeholder {
  color: #9ca3af;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 1rem;
}

/* .filters-section {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
} */

.filter-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-icon {
  color: #6b7280;
  font-size: 0.9rem;
}
.filters-section {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: center;
}


.filter-group select {
  padding: 10px !important;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
  color: #2d3748;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 100%;
}

.filter-group select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.filter-group select option {
  background: white;
  color: #2d3748;
}

/* Selection Controls */
.selection-controls {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 15px 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.selection-info {
  display: flex;
  align-items: center;
  gap: 15px;
  color: #4a5568;
  font-weight: 500;
}

.select-all-btn {
  background: white;
  color: #667eea;
  border: 1px solid #d1d5db;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.8rem;
}

.select-all-btn:hover {
  background: #ffffff;
  border-color: #667eea;
}

.selection-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.selection-actions .action-btn {
  min-width: 120px;
  padding: 8px 16px;
  font-size: 0.8rem;
}

/* Barcode Grid */
.barcode-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.barcode-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.barcode-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-color: #d1d5db;
}

.barcode-card.selected {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.card-header {
  margin-bottom: 16px;
}

.media-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 8px 0;
  line-height: 1.4;
}

.media-divider {
  height: 1px;
  background: #e2e8f0;
  width: 100%;
}

.card-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
}

.media-metadata {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.metadata-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.metadata-label {
  font-weight: 500;
  color: #3b82f6;
  font-size: 0.9rem;
  min-width: 60px;
}

.metadata-value {
  color: #4a5568;
  font-size: 0.9rem;
  font-weight: 400;
}

.media-preview {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  overflow: hidden;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.media-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-preview {
  color: #9ca3af;
  font-size: 1.2rem;
}

.barcode-info {
  flex: 1 1;
  color: #2d3748;
}

.barcode-info h3 {
  font-size: 12px;
  font-weight: 600;
  margin: 0 0 6px 0;
  color: #2d3748;
  overflow: hidden;
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
}

.barcode-info p {
  color: #6b7280;
  margin: 0 0 8px 0;
  font-size: 0.8rem;
}

.barcode-code {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #ffffff;
  padding: 6px 10px;
  border-radius: 6px;
  font-family: 'Courier New', monospace;
  font-weight: 600;
  color: #667eea;
  font-size: 0.8rem;
}

.copy-btn {
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 2px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.copy-btn:hover {
  background: #f3f4f6;
  color: #667eea;
}

.card-content {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.qr-code-section {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.qr-code {
  background: white;
  padding: 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
}

.qr-code:hover {
  border-color: #667eea;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
}

.qr-hint {
  color: #6b7280;
  font-size: 0.75rem;
  margin: 0;
  font-weight: 400;
}

.barcode-stats {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.stat {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  border-bottom: 1px solid #f3f4f6;
}

.stat:last-child {
  border-bottom: none;
}

.stat .label {
  color: #6b7280;
  font-size: 0.8rem;
}

.stat .value {
  color: #2d3748;
  font-weight: 500;
  font-size: 0.8rem;
}

.status {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.status.active {
  background: #dcfce7;
  color: #166534;
}

.status.inactive {
  background: #fee2e2;
  color: #991b1b;
}

.card-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
  min-width: 80px;
  justify-content: center;
  white-space: nowrap;
}

.action-btn.view {
  color: #3b82f6;
  border-color: #dbeafe;
}

.action-btn.view:hover {
  background: #dbeafe;
  border-color: #3b82f6;
}

.action-btn.print {
  color: #f59e0b;
  border-color: #fef3c7;
}

.action-btn.print:hover {
  background: #fef3c7;
  border-color: #f59e0b;
}

.action-btn.refresh {
  color: #8b5cf6;
  border-color: #e9d5ff;
}

.action-btn.refresh:hover {
  background: #e9d5ff;
  border-color: #8b5cf6;
}

.action-btn.deactivate {
  color: #ef4444;
  border-color: #fecaca;
}

.action-btn.deactivate:hover {
  background: #fecaca;
  border-color: #ef4444;
}

.action-btn.activate {
  color: #22c55e;
  border-color: #bbf7d0;
}

.action-btn.activate:hover {
  background: #bbf7d0;
  border-color: #22c55e;
}

.action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.action-btn svg {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #6b7280;
}

.empty-icon {
  font-size: 3rem;
  color: #d1d5db;
  margin-bottom: 15px;
}

.empty-state h3 {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #4b5563;
}

.empty-state p {
  color: #6b7280;
  margin: 0 0 20px 0;
  font-size: 0.9rem;
}

.generate-first-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #667eea;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 200px;
  justify-content: center;
}

.generate-first-btn:hover {
  background: #5a67d8;
  transform: translateY(-1px);
}

/* Modals */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  z-index: 1000;
  padding: 0;
}

.modal-content {
  background: white;
  border-radius: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  box-shadow: none;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e2e8f0;
}

.modal-header h2 {
  font-size: 1.8rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
  text-align: center;
  flex: 1 1;
}

.barcode-viewer .modal-header h2 {
  font-size: 2rem;
  color: #667eea;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.2rem;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: #f3f4f6;
  color: #6b7280;
}

/* Generate Modal */
.generate-content {
  margin-bottom: 20px;
}

.media-selection h3 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 15px 0;
}

.media-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
}

.media-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background: #ffffff;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.media-item:hover {
  background: #f1f5f9;
}

.media-checkbox {
  width: 16px;
  height: 16px;
  accent-color: #667eea;
}

.media-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  flex: 1 1;
}

.media-icon {
  color: #667eea;
  font-size: 1rem;
}

.generate-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.option-group label {
  display: block;
  font-weight: 500;
  color: #2d3748;
  margin-bottom: 6px;
  font-size: 0.9rem;
}

.option-group select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
  color: #2d3748;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.option-group select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.modal-actions .cancel-btn,
.modal-actions .generate-btn {
  min-width: 100px;
  padding: 10px 20px;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.cancel-btn {
  padding: 8px 16px;
  border: 1px solid #d1d5db;
  background: white;
  color: #6b7280;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cancel-btn:hover {
  background: #ffffff;
  border-color: #9ca3af;
}

.generate-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #667eea;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.generate-btn:hover {
  background: #5a67d8;
}

.generate-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.spinning {
  animation: spin 1s linear infinite;
}

/* Barcode Viewer Modal - Full Screen */
.barcode-viewer {
  max-width: 100vw;
  max-height: 100vh;
  width: 100vw;
  height: 100vh;
  margin: 0;
  border-radius: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.barcode-viewer .modal-header {
  background: #ffffff;
  color: #2d3748;
  padding: 20px 30px;
  margin: 0;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.barcode-viewer .modal-header h2 {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.barcode-viewer .close-btn {
  color: #6b7280;
  font-size: 1.2rem;
  background: transparent;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  cursor: pointer;
}

.barcode-viewer .close-btn:hover {
  background: #f3f4f6;
  color: #374151;
  transform: scale(1.05);
}

.viewer-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding: 40px;
  flex: 1 1;
  background: #ffffff;
  overflow-y: auto;
  width: 100%;
  max-width: none;
}

.media-info {
  display: flex;
  flex-direction: column;
  gap: 0;
  background: white;
  padding: 0;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  min-width: 500px;
  flex: 1 1;
}

.media-header {
  padding: 24px 24px 16px 24px;
}

.media-header .media-name {
  font-size: 1.2rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 12px 0;
  line-height: 1.4;
}

.media-header .media-divider {
  height: 1px;
  background: #e2e8f0;
  width: 100%;
}

.media-metadata {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.media-metadata .metadata-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.media-metadata .metadata-label {
  font-weight: 500;
  color: #3b82f6;
  font-size: 0.95rem;
  min-width: 70px;
}

.media-metadata .metadata-value {
  color: #4a5568;
  font-size: 0.95rem;
  font-weight: 400;
}

.media-preview-large {
  width: 100%;
  height: 200px;
  border-radius: 10px;
  overflow: hidden;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.media-preview-large img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-preview-large {
  color: #9ca3af;
  font-size: 2.5rem;
}

.media-details h3 {
  font-size: 1.4rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 15px 0;
  text-align: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #e2e8f0;
}

.media-details p {
  color: #4a5568;
  margin: 0 0 8px 0;
  font-size: 0.95rem;
  font-weight: 500;
  padding: 6px 0;
  border-bottom: 1px solid #f1f5f9;
}

.media-details p:last-child {
  border-bottom: none;
}

.media-details strong {
  color: #667eea;
  font-weight: 600;
  font-size: 0.95rem;
}

.qr-code-large {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  background: white;
  padding: 30px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  justify-content: center;
  min-height: 400px;
  min-width: 400px;
  flex: 1 1;
}

.qr-code-large p {
  color: #4a5568;
  font-size: 1rem;
  margin: 0;
  font-weight: 400;
  text-align: center;
}

.viewer-actions {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
  padding: 30px;
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.05);
  width: 100%;
}

.viewer-actions .action-btn {
  min-width: 120px;
  padding: 10px 20px;
  font-size: 0.9rem;
  font-weight: 600;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.viewer-actions .action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.action-btn.copy {
  color: #3b82f6;
  border-color: #dbeafe;
  max-width: 133px;
  min-width: 110px;
}

.action-btn.copy:hover {
  background: #dbeafe;
  border-color: #3b82f6;
}

.action-btn.print {
  color: #f59e0b;
  border-color: #fef3c7;
}

.action-btn.print:hover {
  background: #fef3c7;
  border-color: #f59e0b;
}

.action-btn.share {
  color: #22c55e;
  border-color: #bbf7d0;
}

.action-btn.share:hover {
  background: #bbf7d0;
  border-color: #22c55e;
}

/* Responsive Design */
@media (max-width: 768px) {
  .barcode-system {
    padding: 15px;
  }

  .barcode-header {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }

  .header-left {
    justify-content: center;
  }

  .barcode-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .selection-controls {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }

  .selection-actions {
    justify-content: center;
  }

  .card-content {
    flex-direction: column;
    gap: 10px;
  }

  .card-actions {
    flex-direction: column;
    gap: 6px;
  }

  .card-actions .action-btn {
    width: 100%;
    min-width: auto;
  }

  .viewer-content {
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    width: 100%;
  }

  .media-info {
    min-width: auto;
  }

  .qr-code-large {
    min-width: auto;
    min-height: 300px;
  }

  .barcode-viewer {
    width: 100vw;
    height: 100vh;
  }

  .barcode-viewer .modal-header {
    padding: 12px 20px;
  }

  .barcode-viewer .modal-header h2 {
    font-size: 1.4rem;
  }

  .media-info {
    padding: 15px;
  }

  .media-preview-large {
    height: 150px;
  }

  .media-details h3 {
    font-size: 1.2rem;
  }

  .qr-code-large {
    padding: 20px;
    min-height: 300px;
  }

  .generate-options {
    grid-template-columns: 1fr;
  }

  .modal-actions {
    flex-direction: column;
    gap: 8px;
  }

  .modal-actions .cancel-btn,
  .modal-actions .generate-btn {
    width: 100%;
    min-width: auto;
  }

  .viewer-actions {
    flex-direction: column;
    gap: 10px;
    padding: 15px;
  }

  .viewer-actions .action-btn {
    width: 100%;
    min-width: auto;
    padding: 10px 15px;
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .page-title h1 {
    font-size: 1.3rem;
  }

  .title-icon {
    font-size: 1.3rem;
  }

  .barcode-card {
    padding: 15px;
  }

  .card-header {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }

  .media-preview {
    width: 80px;
    height: 80px;
    margin: 0 auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/photo-studio/BarcodeSystem.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mEAAmE;EACnE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;;;;GAIG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;AACrB;;;AAGA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,oBAAoB;EACpB,wBAAwB;EACxB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;EACzB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;EACxC,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;AACF","sourcesContent":["/* Simple QR Code System Styles */\n.barcode-system {\n  min-height: 100vh;\n  background: #ffffff;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n  padding: 20px;\n}\n\n/* Loading State */\n.barcode-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: #ffffff;\n  color: #2d3748;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #e2e8f0;\n  border-top: 3px solid #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.barcode-loading p {\n  color: #4a5568;\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n/* Header */\n.barcode-header {\n  background: white;\n  border-bottom: 1px solid #e2e8f0;\n  padding: 20px 0;\n  margin-bottom: 30px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.back-link {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #667eea;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.back-link:hover {\n  color: #5a67d8;\n}\n\n.page-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.title-icon {\n  font-size: 1.5rem;\n  color: #667eea;\n}\n\n.page-title h1 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin: 0;\n}\n\n.header-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.generate-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #667eea;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.generate-btn:hover {\n  background: #5a67d8;\n  transform: translateY(-1px);\n}\n\n/* Filters */\n.barcode-filters {\n  margin-bottom: 30px;\n}\n\n.search-section {\n  margin-bottom: 20px;\n}\n\n.search-box {\n  position: relative;\n  max-width: 400px;\n}\n\n.search-box input {\n  width: 100%;\n  padding: 12px 16px 12px 40px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  background: white;\n  color: #2d3748;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.search-box input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.search-box input::placeholder {\n  color: #9ca3af;\n}\n\n.search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  font-size: 1rem;\n}\n\n/* .filters-section {\n  display: flex;\n  gap: 15px;\n  flex-wrap: wrap;\n} */\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.filter-icon {\n  color: #6b7280;\n  font-size: 0.9rem;\n}\n.filters-section {\n  display: flex;\n  gap: 15px;\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-content: flex-start;\n  align-items: center;\n}\n\n\n.filter-group select {\n  padding: 10px !important;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: white;\n  color: #2d3748;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 100%;\n}\n\n.filter-group select:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.filter-group select option {\n  background: white;\n  color: #2d3748;\n}\n\n/* Selection Controls */\n.selection-controls {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 15px 20px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.selection-info {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  color: #4a5568;\n  font-weight: 500;\n}\n\n.select-all-btn {\n  background: white;\n  color: #667eea;\n  border: 1px solid #d1d5db;\n  padding: 6px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.8rem;\n}\n\n.select-all-btn:hover {\n  background: #ffffff;\n  border-color: #667eea;\n}\n\n.selection-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.selection-actions .action-btn {\n  min-width: 120px;\n  padding: 8px 16px;\n  font-size: 0.8rem;\n}\n\n/* Barcode Grid */\n.barcode-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.barcode-card {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 20px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  margin-bottom: 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.barcode-card:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  border-color: #d1d5db;\n}\n\n.barcode-card.selected {\n  border-color: #667eea;\n  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);\n}\n\n.card-header {\n  margin-bottom: 16px;\n}\n\n.media-name {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin: 0 0 8px 0;\n  line-height: 1.4;\n}\n\n.media-divider {\n  height: 1px;\n  background: #e2e8f0;\n  width: 100%;\n}\n\n.card-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 20px;\n}\n\n.media-metadata {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.metadata-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.metadata-label {\n  font-weight: 500;\n  color: #3b82f6;\n  font-size: 0.9rem;\n  min-width: 60px;\n}\n\n.metadata-value {\n  color: #4a5568;\n  font-size: 0.9rem;\n  font-weight: 400;\n}\n\n.media-preview {\n  width: 60px;\n  height: 60px;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.media-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.video-preview {\n  color: #9ca3af;\n  font-size: 1.2rem;\n}\n\n.barcode-info {\n  flex: 1;\n  color: #2d3748;\n}\n\n.barcode-info h3 {\n  font-size: 12px;\n  font-weight: 600;\n  margin: 0 0 6px 0;\n  color: #2d3748;\n  overflow: hidden;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n  white-space: normal;\n}\n\n.barcode-info p {\n  color: #6b7280;\n  margin: 0 0 8px 0;\n  font-size: 0.8rem;\n}\n\n.barcode-code {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: #ffffff;\n  padding: 6px 10px;\n  border-radius: 6px;\n  font-family: 'Courier New', monospace;\n  font-weight: 600;\n  color: #667eea;\n  font-size: 0.8rem;\n}\n\n.copy-btn {\n  background: none;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 2px;\n  border-radius: 4px;\n  transition: all 0.3s ease;\n}\n\n.copy-btn:hover {\n  background: #f3f4f6;\n  color: #667eea;\n}\n\n.card-content {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 15px;\n}\n\n.qr-code-section {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.qr-code {\n  background: white;\n  padding: 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: 1px solid #e2e8f0;\n}\n\n.qr-code:hover {\n  border-color: #667eea;\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);\n}\n\n.qr-hint {\n  color: #6b7280;\n  font-size: 0.75rem;\n  margin: 0;\n  font-weight: 400;\n}\n\n.barcode-stats {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.stat {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 4px 0;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.stat:last-child {\n  border-bottom: none;\n}\n\n.stat .label {\n  color: #6b7280;\n  font-size: 0.8rem;\n}\n\n.stat .value {\n  color: #2d3748;\n  font-weight: 500;\n  font-size: 0.8rem;\n}\n\n.status {\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.status.active {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.status.inactive {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.card-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.action-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: white;\n  min-width: 80px;\n  justify-content: center;\n  white-space: nowrap;\n}\n\n.action-btn.view {\n  color: #3b82f6;\n  border-color: #dbeafe;\n}\n\n.action-btn.view:hover {\n  background: #dbeafe;\n  border-color: #3b82f6;\n}\n\n.action-btn.print {\n  color: #f59e0b;\n  border-color: #fef3c7;\n}\n\n.action-btn.print:hover {\n  background: #fef3c7;\n  border-color: #f59e0b;\n}\n\n.action-btn.refresh {\n  color: #8b5cf6;\n  border-color: #e9d5ff;\n}\n\n.action-btn.refresh:hover {\n  background: #e9d5ff;\n  border-color: #8b5cf6;\n}\n\n.action-btn.deactivate {\n  color: #ef4444;\n  border-color: #fecaca;\n}\n\n.action-btn.deactivate:hover {\n  background: #fecaca;\n  border-color: #ef4444;\n}\n\n.action-btn.activate {\n  color: #22c55e;\n  border-color: #bbf7d0;\n}\n\n.action-btn.activate:hover {\n  background: #bbf7d0;\n  border-color: #22c55e;\n}\n\n.action-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.action-btn svg {\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: #6b7280;\n}\n\n.empty-icon {\n  font-size: 3rem;\n  color: #d1d5db;\n  margin-bottom: 15px;\n}\n\n.empty-state h3 {\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin: 0 0 8px 0;\n  color: #4b5563;\n}\n\n.empty-state p {\n  color: #6b7280;\n  margin: 0 0 20px 0;\n  font-size: 0.9rem;\n}\n\n.generate-first-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #667eea;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-weight: 500;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 200px;\n  justify-content: center;\n}\n\n.generate-first-btn:hover {\n  background: #5a67d8;\n  transform: translateY(-1px);\n}\n\n/* Modals */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: stretch;\n  justify-content: stretch;\n  z-index: 1000;\n  padding: 0;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n  box-shadow: none;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.modal-header h2 {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0;\n  text-align: center;\n  flex: 1;\n}\n\n.barcode-viewer .modal-header h2 {\n  font-size: 2rem;\n  color: #667eea;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 1.2rem;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.3s ease;\n}\n\n.close-btn:hover {\n  background: #f3f4f6;\n  color: #6b7280;\n}\n\n/* Generate Modal */\n.generate-content {\n  margin-bottom: 20px;\n}\n\n.media-selection h3 {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin: 0 0 15px 0;\n}\n\n.media-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 20px;\n}\n\n.media-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  background: #ffffff;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n}\n\n.media-item:hover {\n  background: #f1f5f9;\n}\n\n.media-checkbox {\n  width: 16px;\n  height: 16px;\n  accent-color: #667eea;\n}\n\n.media-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  flex: 1;\n}\n\n.media-icon {\n  color: #667eea;\n  font-size: 1rem;\n}\n\n.generate-options {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.option-group label {\n  display: block;\n  font-weight: 500;\n  color: #2d3748;\n  margin-bottom: 6px;\n  font-size: 0.9rem;\n}\n\n.option-group select {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: white;\n  color: #2d3748;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.option-group select:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n\n.modal-actions .cancel-btn,\n.modal-actions .generate-btn {\n  min-width: 100px;\n  padding: 10px 20px;\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.cancel-btn {\n  padding: 8px 16px;\n  border: 1px solid #d1d5db;\n  background: white;\n  color: #6b7280;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.cancel-btn:hover {\n  background: #ffffff;\n  border-color: #9ca3af;\n}\n\n.generate-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: #667eea;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.generate-btn:hover {\n  background: #5a67d8;\n}\n\n.generate-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.spinning {\n  animation: spin 1s linear infinite;\n}\n\n/* Barcode Viewer Modal - Full Screen */\n.barcode-viewer {\n  max-width: 100vw;\n  max-height: 100vh;\n  width: 100vw;\n  height: 100vh;\n  margin: 0;\n  border-radius: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n}\n\n.barcode-viewer .modal-header {\n  background: #ffffff;\n  color: #2d3748;\n  padding: 20px 30px;\n  margin: 0;\n  border-bottom: 1px solid #e2e8f0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.barcode-viewer .modal-header h2 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.barcode-viewer .close-btn {\n  color: #6b7280;\n  font-size: 1.2rem;\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.barcode-viewer .close-btn:hover {\n  background: #f3f4f6;\n  color: #374151;\n  transform: scale(1.05);\n}\n\n.viewer-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 40px;\n  padding: 40px;\n  flex: 1;\n  background: #ffffff;\n  overflow-y: auto;\n  width: 100%;\n  max-width: none;\n}\n\n.media-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  background: white;\n  padding: 0;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e2e8f0;\n  min-width: 500px;\n  flex: 1;\n}\n\n.media-header {\n  padding: 24px 24px 16px 24px;\n}\n\n.media-header .media-name {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin: 0 0 12px 0;\n  line-height: 1.4;\n}\n\n.media-header .media-divider {\n  height: 1px;\n  background: #e2e8f0;\n  width: 100%;\n}\n\n.media-metadata {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.media-metadata .metadata-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.media-metadata .metadata-label {\n  font-weight: 500;\n  color: #3b82f6;\n  font-size: 0.95rem;\n  min-width: 70px;\n}\n\n.media-metadata .metadata-value {\n  color: #4a5568;\n  font-size: 0.95rem;\n  font-weight: 400;\n}\n\n.media-preview-large {\n  width: 100%;\n  height: 200px;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid #e2e8f0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.media-preview-large img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.video-preview-large {\n  color: #9ca3af;\n  font-size: 2.5rem;\n}\n\n.media-details h3 {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0 0 15px 0;\n  text-align: center;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.media-details p {\n  color: #4a5568;\n  margin: 0 0 8px 0;\n  font-size: 0.95rem;\n  font-weight: 500;\n  padding: 6px 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.media-details p:last-child {\n  border-bottom: none;\n}\n\n.media-details strong {\n  color: #667eea;\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.qr-code-large {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  background: white;\n  padding: 30px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  justify-content: center;\n  min-height: 400px;\n  min-width: 400px;\n  flex: 1;\n}\n\n.qr-code-large p {\n  color: #4a5568;\n  font-size: 1rem;\n  margin: 0;\n  font-weight: 400;\n  text-align: center;\n}\n\n.viewer-actions {\n  display: flex;\n  gap: 20px;\n  justify-content: center;\n  flex-wrap: wrap;\n  padding: 30px;\n  background: #ffffff;\n  border-top: 1px solid #e2e8f0;\n  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.05);\n  width: 100%;\n}\n\n.viewer-actions .action-btn {\n  min-width: 120px;\n  padding: 10px 20px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.viewer-actions .action-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.action-btn.copy {\n  color: #3b82f6;\n  border-color: #dbeafe;\n  max-width: 133px;\n  min-width: 110px;\n}\n\n.action-btn.copy:hover {\n  background: #dbeafe;\n  border-color: #3b82f6;\n}\n\n.action-btn.print {\n  color: #f59e0b;\n  border-color: #fef3c7;\n}\n\n.action-btn.print:hover {\n  background: #fef3c7;\n  border-color: #f59e0b;\n}\n\n.action-btn.share {\n  color: #22c55e;\n  border-color: #bbf7d0;\n}\n\n.action-btn.share:hover {\n  background: #bbf7d0;\n  border-color: #22c55e;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .barcode-system {\n    padding: 15px;\n  }\n\n  .barcode-header {\n    flex-direction: column;\n    gap: 15px;\n    align-items: stretch;\n  }\n\n  .header-left {\n    justify-content: center;\n  }\n\n  .barcode-grid {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .selection-controls {\n    flex-direction: column;\n    gap: 10px;\n    align-items: stretch;\n  }\n\n  .selection-actions {\n    justify-content: center;\n  }\n\n  .card-content {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .card-actions {\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  .card-actions .action-btn {\n    width: 100%;\n    min-width: auto;\n  }\n\n  .viewer-content {\n    flex-direction: column;\n    gap: 20px;\n    padding: 20px;\n    width: 100%;\n  }\n\n  .media-info {\n    min-width: auto;\n  }\n\n  .qr-code-large {\n    min-width: auto;\n    min-height: 300px;\n  }\n\n  .barcode-viewer {\n    width: 100vw;\n    height: 100vh;\n  }\n\n  .barcode-viewer .modal-header {\n    padding: 12px 20px;\n  }\n\n  .barcode-viewer .modal-header h2 {\n    font-size: 1.4rem;\n  }\n\n  .media-info {\n    padding: 15px;\n  }\n\n  .media-preview-large {\n    height: 150px;\n  }\n\n  .media-details h3 {\n    font-size: 1.2rem;\n  }\n\n  .qr-code-large {\n    padding: 20px;\n    min-height: 300px;\n  }\n\n  .generate-options {\n    grid-template-columns: 1fr;\n  }\n\n  .modal-actions {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .modal-actions .cancel-btn,\n  .modal-actions .generate-btn {\n    width: 100%;\n    min-width: auto;\n  }\n\n  .viewer-actions {\n    flex-direction: column;\n    gap: 10px;\n    padding: 15px;\n  }\n\n  .viewer-actions .action-btn {\n    width: 100%;\n    min-width: auto;\n    padding: 10px 15px;\n    font-size: 0.85rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .page-title h1 {\n    font-size: 1.3rem;\n  }\n\n  .title-icon {\n    font-size: 1.3rem;\n  }\n\n  .barcode-card {\n    padding: 15px;\n  }\n\n  .card-header {\n    flex-direction: column;\n    gap: 10px;\n    text-align: center;\n  }\n\n  .media-preview {\n    width: 80px;\n    height: 80px;\n    margin: 0 auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
